export default __webpack_public_path__ + "static/media/265.53c766a5.gif";